import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams, Link, useNavigate } from "react-router-dom";
import { API_empleos } from "../../config/apiConfig";
import {
  FaArrowUpRightFromSquare,
  FaBuilding,
  FaLocationDot,
} from "react-icons/fa6";
import Navbar from "../../components/Navbar";
import "./css/NuevosRecursos.css";
import { toast } from "react-toastify";
import { useAuth } from "../../context/AuthContext";

const OfertaEMpleo = () => {
  const { id } = useParams();
  const { role } = useSelector((state) => state.auth);
  const [oferta, setOferta] = useState(null);
  const [loading, setLoading] = useState(true);
  const { token } = useAuth();

  /* Botón eliminar oferta */
  const [mostrarModal, setMostrarModal] = useState(false);
  const navigate = useNavigate();

  const handleCancelar = () => {
    setMostrarModal(true);
  };
  const deleteOferta = async () => {
    try {
      const url = `${API_empleos}/${id}`;
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "x-auth-token": token,
        },
      });

      if (response.ok) {
        // Navegar de vuelta a la lista de empleos después de eliminar
        navigate("/admin/empleo");
        toast.success("Oferta eliminada correctamente");
      } else {
        console.error("Error al eliminar la oferta:", response.statusText);
        toast.error("Error al eliminar la oferta");
      }
    } catch (error) {
      console.error("Error al eliminar la oferta:", error);
      toast.error("Error al eliminar la oferta");
    }
  };

  useEffect(() => {
    const fetchOferta = async () => {
      try {
        const response = await fetch(API_empleos, {
          headers: {
            "x-auth-token": token,
          },
        });
        const data = await response.json();

        // Buscar la oferta por _id
        const encontrada = data.find((oferta) => oferta._id === id);
        setOferta(encontrada || null);
      } catch (error) {
        console.error("Error al obtener la oferta:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOferta();
  }, [id, token]);

  const formatearFecha = (fecha) => {
    const date = new Date(fecha);
    return date.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  if (loading) return <p>Cargando oferta...</p>;
  if (!oferta) return <p>No se encontró la oferta.</p>;

  return (
    <>
      <Navbar />

      <main className="main ofertas-usuario">
        <section className="cabecera between">
          <div className="column gap-5">
            <h1 className="titulo-user">{oferta.title}</h1>
            <h2 className="font-18">{oferta.categorySector}</h2>
          </div>

          <div className="flex gap-10">
            {/* Botones editar y eliminar oferta - solo para administradores y tecnico-1 */}
            {(role === "administrador" || role === "tecnico-1") && (
              <Link className="boton" to={`/admin/nuevo-empleo/${oferta._id}`}>
                Editar la oferta de empleo
              </Link>
            )}
            {role === "administrador" && (
              <button
                className="eliminar fondo-rojo blanco"
                onClick={handleCancelar}
              >
                Eliminar esta oferta
              </button>
            )}
          </div>
        </section>

        {mostrarModal && (
          <div className="ventana-cancelar fondo-blanco">
            <div className="column gap-5">
              <p>
                ¿Estás seguro que quieres eliminar la oferta?<br></br>Una vez
                eliminada no habrá forma de recuperarla
              </p>
              <div className="botones flex gap-20">
                <button className="fondo-rojo blanco" onClick={deleteOferta}>
                  Eliminar oferta
                </button>
                <button
                  className="seguir blanco fondo-verde"
                  onClick={() => setMostrarModal(false)}
                >
                  Mantener oferta
                </button>
              </div>
            </div>
          </div>
        )}

        <section className="contenido-principal between">
          <div className="flex-1">
            <p className="bold mb-5">
              Oferta publicada el: {formatearFecha(oferta.initialRegistration)}
            </p>
            <div
              className="w-100"
              style={{
                whiteSpace: "pre-wrap",
                overflowWrap: "anywhere",
              }}
            >
              {oferta.description}
            </div>
            {/* <div dangerouslySetInnerHTML={{ __html: oferta.description.replace(/\n/g, "<br/>") }} /> */}
          </div>

          <div className="caracteristicas column gap-10">
            <p>
              <span className="verde">
                <FaBuilding />
              </span>
              {oferta.company}
            </p>
            <p>
              <span className="verde">
                <FaLocationDot />
              </span>
              {oferta.location}
            </p>
            {oferta.link && (
              <a
                href={oferta.link}
                target="_blank"
                rel="noopener noreferrer"
                className="verde align-center"
              >
                <span className="verde">
                  <FaArrowUpRightFromSquare />
                </span>{" "}
                Link a la oferta original
              </a>
            )}
          </div>
        </section>
      </main>
    </>
  );
};

export default OfertaEMpleo;
